import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "@mantine/core/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/dates/styles.css";
import "./styles.css";

// Dark is the default (spec §6). Read before first paint so a light-mode user
// does not get a dark flash on every load.
document.documentElement.dataset["theme"] =
  localStorage.getItem("neulytics-theme") === "light" ? "light" : "dark";

const root = document.getElementById("root");
if (!root) throw new Error("no #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
